import React, { useState } from 'react'
import Dialog from '../../dialog/Dialog'
import ButtonStartIcon from '../../button/ButtonStartIcon'
import { FormControlLabel, Switch, Typography } from '@mui/material'

const SettingDialog = ({ id, show, onClose, columns = [], handleShowColumns }) => {
  const [form, setForm] = useState(columns.filter((column) => column.hide))

  const onChange = (key, value) => {
    const newColumns = form.map((column) => {
      if (column.key === key) {
        return { ...column, show: value }
      }
      return column
    })
    setForm(newColumns)
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    handleShowColumns(form)
    onClose()
  }

  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onClose}
        color='primary'
        variant='outlined'
        startIcon={["fal","times"]}
      >
        Cancel
      </ButtonStartIcon>
      <ButtonStartIcon
        onClick={onSubmit}
        color='primary'
        variant='contained'
        startIcon={["fal","check"]}
      >
        Confirm
      </ButtonStartIcon>
    </>
  )

  return (
    <Dialog
      id={`setting-${id}`}
      show={show} 
      title="Columns settings"
      onClose={onClose}
      actions={Actions}
    >
      <div className='flex flex-col'>
        { form.map((column) => (
          <FormControlLabel
            key={column.key}
            value={column.key}
            name={column.key}
            className='justify-between'
            control={
              <Switch 
                color="primary"
                checked={column.show}
                onChange={(e) => onChange(column.key, e.target.checked)}
              />
            }
            label={<Typography variant='inherit' color='primary' className='uppercase font-bold'>{column.label}</Typography>}
            labelPlacement="start"
          />
        ))}
      </div>
    </Dialog>
  )
}

export default SettingDialog